import { SHORTCUTS_DATA } from '../config/project-info';

export class KeyboardShortcutsComponent {
  private activeCategory: string = 'All';

  public render(): string {
    const categories = ['All', 'Timeline', 'Composer', 'Navigation', 'Global'];
    const filteredShortcuts = this.activeCategory === 'All'
      ? SHORTCUTS_DATA
      : SHORTCUTS_DATA.filter(s => s.category === this.activeCategory);

    return `
      <section id="shortcuts" class="py-16 md:py-24 border-t border-terminal-border bg-terminal-bgDark/60">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div class="text-center max-w-3xl mx-auto space-y-3 mb-10">
            <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono font-semibold bg-matrix-950/80 text-matrix-400 border border-matrix-800 shadow-glow-sm">
              <span>// KEYBOARD FIRST</span>
            </div>
            <h2 class="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
              Keyboard Reference Cheat Sheet
            </h2>
            <p class="text-sm sm:text-base text-terminal-muted font-mono">
              Designed for touch-typists. Master these bindings to navigate the Fediverse at light speed.
            </p>
          </div>

          <!-- Category Filter Tabs -->
          <div class="flex flex-wrap items-center justify-center gap-2 mb-8">
            ${categories.map(cat => `
              <button 
                data-shortcut-filter="${cat}"
                class="shortcut-filter-btn px-3.5 py-1.5 rounded-lg text-xs font-mono font-semibold transition-all cursor-pointer ${
                  this.activeCategory === cat 
                    ? 'bg-matrix-500 text-terminal-bgDark shadow-glow' 
                    : 'bg-terminal-card text-terminal-muted hover:text-terminal-fg border border-terminal-border'
                }"
              >
                ${cat}
              </button>
            `).join('')}
          </div>

          <!-- Shortcuts Grid -->
          <div id="shortcuts-grid" class="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-3 font-mono">
            ${this.renderShortcutCards(filteredShortcuts)}
          </div>

          <!-- Bottom Note -->
          <div class="mt-8 text-center text-xs font-mono text-terminal-muted flex items-center justify-center gap-2">
            <span>💡 All shortcuts are fully customizable via</span>
            <code class="px-2 py-0.5 rounded bg-terminal-card border border-terminal-border text-matrix-400">~/.config/mastui/keymap.json</code>
            <span>or pressing <strong class="text-matrix-400">o</strong> -> Keybindings</span>
          </div>

        </div>
      </section>
    `;
  }

  private renderShortcutCards(shortcuts: typeof SHORTCUTS_DATA): string {
    return shortcuts.map(s => `
      <div class="p-3.5 rounded-xl bg-terminal-card border border-terminal-border hover:border-matrix-500/60 transition-all flex items-center justify-between gap-3">
        <span class="text-xs text-terminal-fg">${s.action}</span>
        <kbd class="px-2.5 py-1 rounded bg-terminal-bgDark border border-matrix-600/40 text-matrix-400 text-xs font-bold shadow-sm whitespace-nowrap">
          ${s.key}
        </kbd>
      </div>
    `).join('');
  }

  public bindEvents() {
    const filterButtons = document.querySelectorAll('.shortcut-filter-btn');
    const gridEl = document.getElementById('shortcuts-grid');

    filterButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const cat = btn.getAttribute('data-shortcut-filter');
        if (!cat) return;

        this.activeCategory = cat;

        filterButtons.forEach(b => {
          b.className = 'shortcut-filter-btn px-3.5 py-1.5 rounded-lg text-xs font-mono font-semibold transition-all cursor-pointer bg-terminal-card text-terminal-muted hover:text-terminal-fg border border-terminal-border';
        });
        btn.className = 'shortcut-filter-btn px-3.5 py-1.5 rounded-lg text-xs font-mono font-semibold transition-all cursor-pointer bg-matrix-500 text-terminal-bgDark shadow-glow';

        const filtered = this.activeCategory === 'All'
          ? SHORTCUTS_DATA
          : SHORTCUTS_DATA.filter(s => s.category === this.activeCategory);

        if (gridEl) {
          gridEl.innerHTML = this.renderShortcutCards(filtered);
        }
      });
    });
  }
}
